document.addEventListener('DOMContentLoaded', function () {
    const accordionButtons = document.querySelectorAll('[data-accordion-target]');
    if (accordionButtons.length > 0) {

        // let currentlyOpenAccordionId = null; allow only a single accordion to open

        accordionButtons.forEach((button, index) => {
            const targetId = button.getAttribute('data-accordion-target');
            const targetAccordion = document.querySelector(targetId);
            const innerContent = targetAccordion.querySelector('.accordion-inner-content');

            // Open the first accordion by default
            // if (index === 0) {
            //     toggleAccordion(targetAccordion, button, innerContent, true);
            //     currentlyOpenAccordionId = targetId;
            // }

            button.addEventListener('click', function () {
                const isOpen = button.getAttribute('aria-expanded') === 'true';

                // Commented out the code that closes the currently open accordion
                /*
                if (isOpen) {
                    toggleAccordion(targetAccordion, button, innerContent, false);
                    currentlyOpenAccordionId = null;
                } else {
                    if (currentlyOpenAccordionId) {
                        const currentAccordion = document.querySelector(currentlyOpenAccordionId);
                        const currentButton = document.querySelector(`[data-accordion-target="${currentlyOpenAccordionId}"]`);
                        const currentInnerContent = currentAccordion.querySelector('.accordion-inner-content');
                        toggleAccordion(currentAccordion, currentButton, currentInnerContent, false);
                    }

                    toggleAccordion(targetAccordion, button, innerContent, true);
                    currentlyOpenAccordionId = targetId;
                }
                */

                // New code to allow multiple accordions to open
                toggleAccordion(targetAccordion, button, innerContent, !isOpen);
            });
        });

        function toggleAccordion(accordion, button, innerContent, open) {
            const icon = button.querySelector('svg');
            const accordionType = button.getAttribute('data-accordion-type');
        
            if (open) {
                accordion.classList.remove('invisible', 'max-h-0');
                accordion.classList.add('visible');
                innerContent.classList.remove('opacity-0');
                innerContent.classList.add('opacity-100');
                button.setAttribute('aria-expanded', 'true');
        
                if (accordionType === 'main') {
                    // For the main accordion, change the icon to 'minus'
                    icon.innerHTML = '<path stroke-linecap="round" stroke-linejoin="round" d="M5 12h14" />';
                } else if (accordionType === 'job') {
                    // For the job accordion, add the class to flip the icon vertically
                    icon.classList.add('rotate-180');
                }

                // Calculate position to scroll to, 100px above the accordion
                const accordionTopPosition = accordion.getBoundingClientRect().top + window.pageYOffset - 300;
                window.scrollTo({ top: accordionTopPosition, behavior: 'smooth' });

            } else {
                innerContent.classList.remove('opacity-100');
                innerContent.classList.add('opacity-0');
                accordion.classList.remove('visible');
                accordion.classList.add('invisible', 'max-h-0');
                button.setAttribute('aria-expanded', 'false');
        
                if (accordionType === 'main') {
                    // For the main accordion, change the icon back to 'plus'
                    icon.innerHTML = '<path stroke-linecap="round" stroke-linejoin="round" d="M12 4.5v15m7.5-7.5h-15" />';
                } else if (accordionType === 'job') {
                    // For the job accordion, remove the class to flip the icon back
                    icon.classList.remove('rotate-180');
                }
            }
        }        
           
    }
});
